/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RouteTagDtoBase
 * auto generated base class for the model RouteTagDtoModel.
 */
export const RouteTagDtoModelBase = ModelBase
  .named('RouteTagDto')
  .props({
    __typename: types.optional(types.literal("RouteTagDto"), "RouteTagDto"),
    uuid: types.identifier,
    name: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteTagDtoModelSelector extends QueryBuilder {
  get uuid() { return this.__attr(`uuid`) }
  get name() { return this.__attr(`name`) }
}
export function selectFromRouteTagDto() {
  return new RouteTagDtoModelSelector()
}

export const routeTagDtoModelPrimitives = selectFromRouteTagDto().uuid.name
